export const nonEditableFieldMock = [
  {id: 1, fieldName: 'caseNumber', analyzerName: 'Consilio Standard Text'},
  {id: 2, fieldName: 'plaintiffName', analyzerName: 'Standard Text'},
  {id: 3, fieldName: 'defendantName', analyzerName: 'Standard Text'},
  {id: 4, fieldName: 'courtName', analyzerName: 'Consilio Standard Text'},
  {id: 5, fieldName: 'judgeName', analyzerName: 'Standard Text'},
  {id: 6, fieldName: 'filingDate', analyzerName: 'Standard Text'},
  {id: 7, fieldName: 'hearingDate', analyzerName: 'Standard Text'},
  {id: 8, fieldName: 'caseSummary', analyzerName: 'Consilio Standard Text'},
  {id: 9, fieldName: 'legalArgument', analyzerName: 'Consilio Standard Text'},
  {id: 10, fieldName: 'verdictText', analyzerName: 'Consilio Standard Text'},
  {id: 11, fieldName: 'statuteReference', analyzerName: 'Standard Text'},
  {id: 12, fieldName: 'regulationCode', analyzerName: 'Standard Text'},
  {id: 13, fieldName: 'attorneyName', analyzerName: 'Standard Text'},
  {id: 14, fieldName: 'lawFirmName', analyzerName: 'Consilio Standard Text'},
  {id: 15, fieldName: 'contractTitle', analyzerName: 'Consilio Standard Text'},
  {id: 16, fieldName: 'contractClause', analyzerName: 'Consilio Standard Text'},
  {id: 17, fieldName: 'agreementType', analyzerName: 'Standard Text'},
  {
    id: 18,
    fieldName: 'evidenceDescription',
    analyzerName: 'Consilio Standard Text',
  },
  {
    id: 19,
    fieldName: 'witnessStatement',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 20, fieldName: 'depositionText', analyzerName: 'Consilio Standard Text'},
  {id: 21, fieldName: 'legalCitation', analyzerName: 'Standard Text'},
  {
    id: 22,
    fieldName: 'caseLawReference',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 23, fieldName: 'appealStatus', analyzerName: 'Standard Text'},
  {id: 24, fieldName: 'jurisdiction', analyzerName: 'Standard Text'},
  {id: 25, fieldName: 'documentPath', analyzerName: 'Path'},
  {id: 26, fieldName: 'evidenceFilePath', analyzerName: 'Path'},
  {id: 27, fieldName: 'courtEmail', analyzerName: 'Email / URL'},
  {id: 28, fieldName: 'attorneyEmail', analyzerName: 'Email / URL'},
  {id: 29, fieldName: 'lawFirmWebsite', analyzerName: 'Email / URL'},
  {
    id: 30,
    fieldName: 'legalNoticeText',
    analyzerName: 'Consilio Standard Text',
  },
  {
    id: 31,
    fieldName: 'complianceRequirement',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 32, fieldName: 'regulatoryBody', analyzerName: 'Standard Text'},
  {
    id: 33,
    fieldName: 'intellectualPropertyType',
    analyzerName: 'Standard Text',
  },
  {
    id: 34,
    fieldName: 'patentDescription',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 35, fieldName: 'trademarkName', analyzerName: 'Standard Text'},
  {
    id: 36,
    fieldName: 'copyrightDetails',
    analyzerName: 'Consilio Standard Text',
  },
  {
    id: 37,
    fieldName: 'settlementTerms',
    analyzerName: 'Consilio Standard Text',
  },
  {
    id: 38,
    fieldName: 'penaltyDescription',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 39, fieldName: 'fineAmountDescription', analyzerName: 'Standard Text'},
  {id: 40, fieldName: 'legalMemoText', analyzerName: 'Consilio Standard Text'},
  {id: 41, fieldName: 'internalNotes', analyzerName: 'Consilio Standard Text'},
  {
    id: 42,
    fieldName: 'documentLanguageCJK',
    analyzerName: 'Consilio Standard CJK',
  },
  {
    id: 43,
    fieldName: 'translatedLegalTextCJK',
    analyzerName: 'Consilio Standard CJK',
  },
  {
    id: 44,
    fieldName: 'complianceReport',
    analyzerName: 'Consilio Standard Text',
  },
  {
    id: 45,
    fieldName: 'investigationSummary',
    analyzerName: 'Consilio Standard Text',
  },
  {id: 46, fieldName: 'policyReference', analyzerName: 'Standard Text'},
  {id: 47, fieldName: 'caseCategory', analyzerName: 'Standard Text'},
  {id: 48, fieldName: 'litigationStage', analyzerName: 'Standard Text'},
  {id: 49, fieldName: 'discoveryNotes', analyzerName: 'Consilio Standard Text'},
  {
    id: 50,
    fieldName: 'documentReviewComments',
    analyzerName: 'Consilio Standard Text',
  },
];
